import React, { Fragment, useState } from "react";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";
import MedicationFilters from "./MedicationFilters";
import MedicationList from "./MedicationList";
import Error from "./Error";

const apiUrl = "/wp-json/salesforce/v1/medications";

const Medications = props => {
  const [letter, setLetter] = useState("");
  const [loading, response, error] = useGet(apiUrl);

  return (
    <Fragment>
      <MedicationFilters
        letter={letter}
        setLetter={setLetter}
        results={response && !loading ? response.data.medications : null}
      />

      {loading && <Loading label="Searching..." />}

      {response && !loading && (
        <MedicationList
          letter={letter}
          results={response && !loading ? response.data.medications : null}
        />
      )}

      {error && <Error />}
    </Fragment>
  );
};

export default Medications;
